// extracted by mini-css-extract-plugin
export default {"fileUpload":"jBhNmRw7c2KMzrJlhy0K","fileUploadText":"fT1ilarIQ9CzZ11SiNG8","activeStyle":"l5OCcCS9xGj9vyPbgxD5","rejectStyle":"AgvVEEcGd4Yz5bIG28Ou"};